var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25628 16.3687C6.91457 16.027 6.91457 15.473 7.25628 15.1313L11.8876 10.5L7.25628 5.86872C6.91457 5.52701 6.91457 4.97299 7.25628 4.63128C7.59799 4.28957 8.15201 4.28957 8.49372 4.63128L13.7437 9.88128C14.0854 10.223 14.0854 10.777 13.7437 11.1187L8.49372 16.3687C8.15201 16.7104 7.59799 16.7104 7.25628 16.3687Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.26df4d5f2a76e65062324023bbc164f6.svg";
export { ForwardRef as ReactComponent };